import React from 'react';
import { Modal } from '../../Modals/Modal';
import { EShopButton } from '../../../atoms/Buttons/EShopButton';
import { useSelector } from 'react-redux';
import { getUserSidebar } from '../../../../store/selectors/user/user.selectors';
import { ChallengeBanner } from '../../../atoms/Widgets/ChallengeBanner';
import { firstCharToUpperCase } from 'helpers/text/firstCharToUpperCase';
import { trackEvent } from 'services/matomo/trackEvent';
import {
  CURRENT_CHALLENGE_SEASON,
  CURRENT_CHALLENGE_YEAR
} from 'helpers/challenge/getChallengeInfos';

export const PublicShopModal = () => {
  const user = useSelector(getUserSidebar);
  const year = CURRENT_CHALLENGE_YEAR;
  const isFirstVisit = localStorage.getItem('isFirstVisit') !== 'false';
  if (isFirstVisit) {
    localStorage.setItem('isFirstVisit', 'false');
  }
  return (
    <Modal
      modalHead={`Aide e-boutique`}
      isShowingDefault={isFirstVisit}
      triggerButton={
        <EShopButton
          title="Informations importantes"
          variant={CURRENT_CHALLENGE_SEASON}
          onClick={() =>
            trackEvent('Eshop', 'Clicked', 'Modal informations importantes')
          }
        />
      }
    >
      <ChallengeBanner season={CURRENT_CHALLENGE_SEASON} year={year} />
      <p>
        Bienvenue sur ma e-boutique ! Je suis {user.firstname}. Je participe
        avec mon établissement ({user.lycee.name}) à{' '}
        {firstCharToUpperCase(user.lycee.ville)} à une opération pédagogique de
        vente avec France Challenges. Grâce à ma e-boutique, je peux envoyer des
        délices gourmands partout en France. À offrir ou pour vous faire
        plaisir, je ne doute pas que vous découvriez de quoi vous satisfaire.
      </p>
      <h2>
        Qu'est-ce que la e-boutique ?{' '}
        <span role="img" aria-label="emoji pensif">
          🤔
        </span>
      </h2>
      <p>
        La e-boutique me permet de vendre à distance. Vous pouvez directement
        accéder à mon catalogue France Challenges et commander en ligne avec un
        paiement via une plateforme sécurisée LCL.
      </p>
      <h2>
        Pourquoi commander sur ma e-boutique ?{' '}
        <span role="img" aria-label="emoji carton">
          📦
        </span>
      </h2>
      <p>
        Votre commande me permettra de monter en compétences sur la vente
        omnicanale et d'enrichir mes dossiers pour mes examens. En plus, cela
        contribuera à réunir des fonds pour financer un projet scolaire et
        soutenir une ONG.
      </p>
      <h2>
        Conseils pratiques{' '}
        <span role="img" aria-label="emoji note">
          📝
        </span>
      </h2>
      <ul style={{ marginLeft: '1rem' }}>
        <li>
          Si vous êtes loin de moi, je vous propose de commander directement ici
          sur ma e-boutique en choisissant la livraison en point relais.
        </li>
        <li>
          Si nous sommes proches géographiquement, je vous invite à me
          recontacter pour passer commande avec moi directement, cela vous
          permettra de n'avoir aucuns frais de port et je vous livrerai
          personnellement.
        </li>
      </ul>
      <h2>
        Livraison{' '}
        <span role="img" aria-label="emoji camion">
          🚚
        </span>
      </h2>
      <p>
        La livraison est prévue à la fin de notre challenge de vente,
        c'est-à-dire{' '}
        {CURRENT_CHALLENGE_SEASON === 'autumn'
          ? `entre mi-novembre et mi-décembre ${year}`
          : `courant mai ${year}`}
        .
      </p>
    </Modal>
  );
};
